import { render } from "./Sensores.vue?vue&type=template&id=81c2eca8&scoped=true"
import script from "./Sensores.vue?vue&type=script&lang=js"
export * from "./Sensores.vue?vue&type=script&lang=js"

import "./Sensores.vue?vue&type=style&index=0&id=81c2eca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c2eca8"]])

export default __exports__